/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:3b7baf32-103a-47f7-939c-b2f9312eb4d1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_MepGCq9MD",
    "aws_user_pools_web_client_id": "5od24dnmaqbm3stbocjkaauqph",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://nec17h9ioc.execute-api.eu-central-1.amazonaws.com/release",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://6qgx3v2jqvbjroes3zqcqepvf4.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "mat-test-storage201343-release",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
